import Big from 'big.js';
import {baseToIntConvertFunction, intToBase} from '../../../../helpers/base-conversions';

export const add = (num1, num2, base, maxLength = 16) => {
  try {
    if (base === 10) {
      const result = Big(num1).plus(Big(num2));
      return getResultWithPrecision(result, maxLength);
    }

    return intToBase(
      baseToIntConvertFunction[base](num1) + baseToIntConvertFunction[base](num2),
      base
    ).toUpperCase();
  } catch (err) {
    console.log(err);
  }
};

export const subtract = (num1, num2, base, maxLength = 16) => {
  try {
    if (base === 10) {
      const result = Big(num1).minus(Big(num2));
      return getResultWithPrecision(result, maxLength);
    }

    return intToBase(
      baseToIntConvertFunction[base](num1) - baseToIntConvertFunction[base](num2),
      base
    ).toUpperCase();
  } catch (err) {
    console.log(err);
  }
};

export const multiply = (num1, num2, base, maxLength = 16) => {
  try {
    if (base === 10) {
      const result = Big(num1).times(Big(num2));
      return getResultWithPrecision(result, maxLength);
    }

    return intToBase(
      baseToIntConvertFunction[base](num1) * baseToIntConvertFunction[base](num2),
      base
    ).toUpperCase();
  } catch (err) {
    console.log(err);
  }
};

export const divide = (numerator, denominator, base, maxLength = 16) => {
  try {
    if (base === 10) {
      const result = Big(numerator).div(Big(notZero(denominator)));
      return getResultWithPrecision(result, maxLength);
    }

    return intToBase(
      baseToIntConvertFunction[base](numerator) /
        notZero(baseToIntConvertFunction[base](denominator)),
      base
    ).toUpperCase();
  } catch (err) {
    console.log(err);
  }
};

const getResultWithPrecision = (result, precision) => {
  const stringResult = result.toString();
  const wholeNumberLength = stringResult.split('.')?.[0]?.length;

  if (wholeNumberLength > precision) {
    return result.toExponential(precision);
  }

  if (stringResult.length <= precision) {
    return stringResult;
  }

  const preciseResult = result.toPrecision(precision).replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1');
  if (preciseResult.length <= precision) {
    return preciseResult;
  }

  const fixedResult = Big(preciseResult)
    .toFixed(precision - wholeNumberLength)
    .replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1');
  return fixedResult;
};

const notZero = (n) => {
  n = +n; // Coerce to number.
  if (!n) {
    // Matches +0, -0, NaN
    throw new Error('Invalid dividend ' + n);
  }
  return n;
};
